const postStartStreamResponse = (response) => {
  return response?.data;
};

export default postStartStreamResponse;
